import React, { useState, useEffect } from "react";
import { Button, Modal, Table, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import styles from '../../../styles/FarmGlobal/MateriaisComposicao.module.scss';
import { useFGMateriaisComposicao } from "../../../contexts/FarmGlobal/MateriaisComposicaoContext";
import axios from 'axios';
import MaterialIcon from 'material-icons-react';
import ModalConfirmacao from "./ModalConfirmacao";

const ModalCadComposicaoEditar = ({ idMaterial, showCad, setShowCad }) => {
    const {
        materialAtivo,
        setMaterialAtivo,
        materialComposicaoAtivo,
        setmaterialComposicaoAtivo,       
        setFile,
        handleAddComposicaoEdit,
        handleRemoveComposicaoEdit,
        handleChangeComposicaoEdit,
        handleChange,
        handleFileChange,
        handleChangeTipo,
        handleSaveUpperCase,
        removeAccents,
        fetchMaterialInfo,
        isLoading, setIsLoading,
        materialSelecionado,
        handleSaveUpdateMaterial,
        handleChangeMaterialAtivo,
        handleShowPDF,
        file,
        showConfirmacaoEdit,       
        setShowConfirmacaoEdit, 
        inputFornecedorValue, setInputFornecedorValue  ,        
        handleFornecedorCreate,
        handleFornecedorConfirm,
        handleFornecedorSave, 
    } = useFGMateriaisComposicao();

    const { showCadMaterial, setShowCadMaterial,
        tiposFibra,
        fornecedoresPa,
        fornecedoresMp
    } = useFGMateriaisComposicao();

    

    // Fetch material information when modal opens
    useEffect(() => {
        if (materialSelecionado?.IdMaterial) {
            fetchMaterialInfo(materialSelecionado.IdMaterial);            
        }
    }, [materialSelecionado]);

    const handleKeyDown = (e, type) => {
    if (e.key === 'Enter' && inputFornecedorValue) {    
      handleFornecedorCreate(inputFornecedorValue, type);
    }
  };
    
    return (
        <>
            <Modal
                show={showCadMaterial}
                onHide={() => setShowCadMaterial(false)}
                backdrop="static"
                keyboard={false}
                centered
                size="xl"
            >
                <Modal.Header>
                    <Modal.Title>Alterar Informações de Composição</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    {isLoading ? (
                        <div>Carregando...</div>
                    ) : (
                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Descrição Material <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            name="Descricao" 
                                            value={removeAccents(materialAtivo?.Descricao || '')} 
                                            onChange={handleChangeMaterialAtivo}                                            
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Código Fornecedor</Form.Label>
                                    <Form.Control
                                        name="CodigoFornecedor"
                                        type="text"
                                        value={materialAtivo?.CodigoFornecedor}
                                        onChange={handleChangeMaterialAtivo}
                                        min="1"
                                        onKeyPress={(e) => {
                                            if (e.key === '-') e.preventDefault();
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Gramatura (g/m²) <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control
                                            name="Gramatura"
                                            type="number"
                                            value={materialAtivo?.Gramatura || ''}
                                            onChange={handleChangeMaterialAtivo}
                                            min="1"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Tipo <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <div>
                                            <Form.Check
                                                inline
                                                label="Tinto"
                                                type="checkbox"
                                                checked={materialAtivo?.Tipo == 'T'}                                                
                                                onChange={(e) =>
                                                    setMaterialAtivo((prev) => ({
                                                    ...prev,
                                                    Tipo: 'T',
                                                    }))
                                                }
                                                name="Tipo"
                                            />
                                            <Form.Check
                                                inline
                                                label="Estampado Cilindro"
                                                type="checkbox"
                                                checked={materialAtivo?.Tipo == 'EC'}                                                
                                                onChange={(e) =>
                                                    setMaterialAtivo((prev) => ({
                                                    ...prev,
                                                    Tipo: 'EC',
                                                    }))
                                                }
                                                name="Tipo"                                               
                                            />
                                            <Form.Check
                                                inline
                                                label="Estampado Digital"
                                                type="checkbox"
                                                checked={materialAtivo?.Tipo == 'ED'}                                                                                               
                                                name="Tipo"
                                                onChange={(e) =>
                                                    setMaterialAtivo((prev) => ({
                                                    ...prev,
                                                    Tipo: 'ED',
                                                    }))
                                                }
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Ref Linx</Form.Label>
                                        <Form.Control 
                                            name="RefLinx" 
                                            value={materialAtivo?.RefLinx || ''} 
                                            onChange={handleChangeMaterialAtivo} 
                                            //readOnly={true}
                                            //disabled ={true}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                <Form.Group>
                                        <Form.Label>Fornecedor MP</Form.Label>
                                        <Select
                                        name='IdFornecedorMp'
                                        options={fornecedoresMp.map(f => ({
                                            label: f.Fornecedor,
                                            value: f.IdFornecedor
                                        }))}
                                        value={fornecedoresMp.find(f => f.IdFornecedor == materialAtivo.IdFornecedorMp) 
                                        ? { label: fornecedoresMp.find(f => f.IdFornecedor == materialAtivo.IdFornecedorMp).Fornecedor, 
                                            value: materialAtivo.IdFornecedorMp 
                                            } 
                                        : null}                                                                    
                                        onChange={(e) =>
                                                    setMaterialAtivo((prev) => ({
                                                    ...prev,
                                                    IdFornecedorMp: e?.value,
                                                    }))
                                                }     
                                        onInputChange={(value) => setInputFornecedorValue(value)} 
                                        onKeyDown={(e) => handleKeyDown(e, 'Mp')} 
                                        placeholder="Selecione ou digite para buscar..."
                                        isSearchable
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Fornecedor PA</Form.Label>
                                        <Select
                                        name='IdFornecedorPa'
                                        options={fornecedoresPa.map(f => ({
                                            label: f.Fornecedor,
                                            value: f.IdFornecedor
                                        }))}
                                        value={fornecedoresPa.find(f => f.IdFornecedor == materialAtivo.IdFornecedorPa) 
                                        ? { label: fornecedoresPa.find(f => f.IdFornecedor == materialAtivo.IdFornecedorPa).Fornecedor, 
                                            value: materialAtivo.IdFornecedorPa
                                            } 
                                        : null}                                     
                                        onChange={(e) =>
                                                    setMaterialAtivo((prev) => ({
                                                    ...prev,
                                                    IdFornecedorPa: e?.value,
                                                    }))
                                                }     
                                        onInputChange={(value) => setInputFornecedorValue(value)} 
                                        onKeyDown={(e) => handleKeyDown(e, 'Pa')}
                                        placeholder="Selecione ou digite para buscar..."
                                        isSearchable
                                        />
                                    </Form.Group>
                            </Col>
                            </Row>
                            <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>                                 
                                        {materialAtivo?.Arquivo && (
                                            <Button 
                                                variant="primary"
                                                onClick={() => handleShowPDF(materialAtivo?.Arquivo)} 
                                                title="Visualizar Ficha Técnica" 
                                            >
                                                Visualizar Ficha Técnica
                                            </Button>
                                        )}
                                        <Form.Label htmlFor="file-upload" className="btn btn-warning" style={{height: '30px', marginTop:'5px', marginLeft: '5px'}}>
                                            Selecionar Nova Ficha Técnica
                                        </Form.Label>
                                        <Form.Control 
                                            id="file-upload"
                                            type="file" 
                                            accept=".pdf" 
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }} // Esconde o input de arquivo padrão
                                        />
                                         {file && ` Arquivo: ${file.name}`}
                                    
                                   
                                </Form.Group>
                            </Col>


                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <h5>Composição</h5>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>(%)</th>
                                                <th>Tipo de Fibra</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {materialComposicaoAtivo && materialComposicaoAtivo.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            value={item.PercFibra}
                                                            onChange={(e) => handleChangeComposicaoEdit(index, 'PercFibra', e.target.value)}
                                                            min="1"
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            as="select"
                                                            value={item.IdTipoFibra}
                                                            onChange={(e) => handleChangeComposicaoEdit(index, 'IdTipoFibra', e.target.value)}
                                                        >
                                                            {tiposFibra.map((tipo) => (
                                                                <option key={tipo.IdTipoFibra} value={tipo.IdTipoFibra}>
                                                                    {tipo.TipoFibra}
                                                                </option>
                                                            ))}
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Button variant="danger" onClick={() => handleRemoveComposicaoEdit(index)}>
                                                            Remover
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    <Button onClick={handleAddComposicaoEdit}>Adicionar Composição</Button>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {setShowCadMaterial(false);}}>Cancelar</Button>
                    <Button variant="primary" onClick={() => setShowConfirmacaoEdit(true)}>Gravar</Button>                    
                </Modal.Footer>
            </Modal>  
             <ModalConfirmacao/>          
        </>
    );
}

export default ModalCadComposicaoEditar;
